<template>
<div>
    <GChart style="height:300px" type="PieChart" :data="chartData" :options="chartOptions" :events="chartEvents" ref="chart" />
    <br/>
    <v-expansion-panel>
        <v-expansion-panel-content v-for="(group, groupName) in groupedItems" :key="groupName" >
         <div slot="header">{{groupName}}</div>
        <v-card v-for="item in group.data" :key="item.key">
            <v-card-text>{{item.clients}}</v-card-text>
        </v-card>
        </v-expansion-panel-content>
    </v-expansion-panel>


</div>
</template>

<script>
import DataHelpers from '../helpers/DataHelpers.js'
import FirebaseHelpers from '../helpers/FirebaseHelpers.js'



export default {
    data() {
        return {
            items: [],

            // chartData: [
            //     ['Year', 'Sales', 'Expenses', 'Profit'],
            //     ['2014', 1000, 400, 200],
            //     ['2015', 1170, 460, 250],
            //     ['2016', 660, 1120, 300],
            //     ['2017', 1030, 540, 350]
            // ],
            chartOptions: {
           
                title: '',
                pieHole: 0.4,
                'chartArea': {'width': '100%', 'height': '80%'},
               'legend': {'position': 'right'},
               backgroundColor: { fill:'transparent' }
            //    'legend': 'none',
                // subtitle: 'Sales, Expenses, and Profit: 2014-2017',
        
            },

            chartEvents: {
            'select': (e) => {
                let chartObj = this.$refs.chart.chartObject
                let selection = chartObj.getSelection()
                if(!selection || !selection.length)
                    return

                let row = selection[0].row
                console.log( this.chartData[row+1][0])
            }
        }


        }
    },

    components: {
        
    },
    
    props: {
        dash: Object,
    },

    computed: {
        groupedItems() {
            if(!this.dash.field)
                return {}
            const field = this.dash.field
    
            let groupedItems = {}
            this.items.forEach(item => {
                let name = item[field]
                if(!groupedItems[name])
                    groupedItems[name] = {count: 0, data:[]}
                groupedItems[name].count += 1
                groupedItems[name].data.push(item)
            })
            return groupedItems
        },
        chartData() {
            let data = [
                ['Type', 'Leads']
            ]
            
            for(let group in this.groupedItems) {
                let row = []
                row.push(group)
                let count = this.groupedItems[group].count
                row.push(count)
                data.push(row)
            }
            return data
        }


    },

    methods: {
        function1() {

        },
    },

    created() {

    },

    watch: {
        dash: {
            immediate:true,

            handler: function(newVal) {
                if(!this.dash.section)
                    return
                let ref = DataHelpers.getTransactionSummaryRef().child(this.dash.section)
                
                ref.on('value', snap => {
                    
                    this.items = FirebaseHelpers.snapshotToArray(snap)
                })
            }
        }
    }
}
</script>

<style scoped>
   
</style>




// WEBPACK FOOTER //
// Dashboard.vue?6157c473